import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { STORE_FEATURE_KEY_MESSAGE_FILTER } from './message-filter.reducer';

const destinatorFiltersSelector = (appState: any) => appState[STORE_FEATURE_KEY_MESSAGE_FILTER].destinatorFilters;
const loadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_MESSAGE_FILTER].loading;
const savingSelector = (appState: any) => appState[STORE_FEATURE_KEY_MESSAGE_FILTER].saving;
const savedSelector = (appState: any) => appState[STORE_FEATURE_KEY_MESSAGE_FILTER].saved;

@Injectable()
export class MessageFilterSelectors {
    constructor(private store: Store<any>) {
    }

    selectDestinatorFilters(): Observable<Array<any>> {
        return this.store
            .pipe(select(destinatorFiltersSelector));
    }

    selectLoading(): Observable<boolean> {
        return this.store
            .pipe(select(loadingSelector));
    }

    selectSaving(): Observable<boolean> {
        return this.store
            .pipe(select(savingSelector));
    }

    selectSaved(): Observable<boolean> {
        return this.store
            .pipe(select(savedSelector));
    }
}
